module.exports = __webpack_public_path__ + "static/media/version.d233662f.bin";


//////////////////
// WEBPACK FOOTER
// ./src/version
// module id = 1284
// module chunks = 49